import React from 'react';
import { componentService } from 'js/services/component.service';

export const LoginNotificationsPreferences = React.lazy(() => import(/* webpackChunkName: "login-notifications-preferences" */ './LoginNotificationsPreferences'));

// <hub2-login-notifications-preferences></hub2-login-notifications-preferences>
componentService.registerWebContentComponents({ LoginNotificationsPreferences });
